'use client'

import { Button } from '@vinted/web-ui'

import { PRO_INTEGRATIONS_APPLICATION_PATH } from '@marketplace-web/domain/business-accounts'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = Omit<ComponentProps<typeof Button>, 'url' | 'urlProps'>

const ApplicationButton = (props: Props) => {
  const translate = useTranslate('business.pro_integrations.application_button')

  return <Button text={translate('action')} {...props} url={PRO_INTEGRATIONS_APPLICATION_PATH} />
}

export default ApplicationButton
